import React from "react";
import { About, Footer, Header, Skills, Testimonial, Work } from "container";
import { Navbar, FirstLoad, IntroducePopup } from "components";
import SocialMedia from "components/SocialMedia/SocialMedia";

const HomeLandingPage = () => {
  return (
    <>
      <IntroducePopup />
      <Navbar />
      <Header />
      <About />
      <Work />
      <Skills />
      <Testimonial />
      <Footer />
      <SocialMedia />
    </>
  );
};

export default HomeLandingPage;
